import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const AdminModal = ({
  isOpen,
  onClose,
  title,
  children,
  actions,
  containerClassName = 'modal-container',
  headerClassName,
  wrapContent = true,
}) => {
  if (!isOpen) return null;

  const headerClass = headerClassName ? `modal-header ${headerClassName}` : 'modal-header';

  return (
    <div className="modal-overlay">
      <div className={containerClassName}>
        <div className={headerClass}>
          {typeof title === 'string' ? <h2>{title}</h2> : title}
          <button type="button" className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        {wrapContent ? <div className="modal-content">{children}</div> : children}
        {actions ? <div className="modal-actions">{actions}</div> : null}
      </div>
    </div>
  );
};

export default AdminModal;
